import * as React from 'react'
import { TabList, Tab } from '@astryxdesign/core/TabList'
import { settingsViews, type SettingsView } from './adminNavigation'

export function Settings({ view, onViewChange, pages }: {
  view: SettingsView; onViewChange: (view: SettingsView) => void; pages: Record<SettingsView, React.ReactNode>
}) {
  const [visited, setVisited] = React.useState<Set<SettingsView>>(() => new Set([view]))
  React.useEffect(() => { setVisited(previous => previous.has(view) ? previous : new Set([...previous, view])) }, [view])
  return <div className="page-stack">
    <TabList className="admin-tabs" aria-label="Settings sections" value={view} onChange={value => onViewChange(value as SettingsView)} size="md" overflow="scroll" hasDivider>
      {(Object.keys(settingsViews) as SettingsView[]).map(item => <Tab key={item} value={item} label={settingsViews[item]} />)}
    </TabList>
    {(Object.keys(settingsViews) as SettingsView[]).map(item => (visited.has(item) || item === view) && <div key={item} hidden={view !== item} aria-hidden={view !== item}>{pages[item]}</div>)}
  </div>
}
